const wrapper = document.querySelector('.svg-wrapper');
const headerHeight = document.querySelector('header').offsetHeight;
const animationDuration = 8000;

let currentlyAnimated = 0;
let currentSvg;
let currentPath;
let oldPathLength;
let pathLength;
let lastScrollPosition = 0;
let animationComplete = false;
let animateTimeout = null;
let nowAnimatingFor = 0;
let animationStartedAt = 0;
let animationOrder = [];
let windowSize = {
    height: window.innerHeight,
    width: window.innerWidth
};

function generateSVGs (type) {
  const height = wrapper.offsetHeight;
  const width = window.innerWidth > 1400 ? 1386 : wrapper.offsetWidth - 16;
  const svgHeight = height;

  let angleBlocks, keyPoints, pathArray, pathArrayHeights, cornerVertical, cornerHorizontal,
      cornerBottomRight, cornerTopLeft, cornerBottomLeft, cornerTopRight;

  if (window.innerWidth > 767) {
    cornerVertical = 105 * width / 1386;
    cornerHorizontal = 105 * width / 1386;
    cornerBottomRight = `s0 ${cornerVertical} ${0 - cornerHorizontal} ${cornerVertical}`;
    cornerTopLeft = `s${0 - cornerHorizontal} 0 ${0 - cornerHorizontal} ${cornerVertical}`;
    cornerBottomLeft = `s0 ${cornerVertical} ${cornerHorizontal} ${cornerVertical}`;
    cornerTopRight = `s${cornerHorizontal} 0 ${cornerHorizontal} ${cornerVertical}`;
    angleBlocks = [...document.querySelectorAll('[data-line-point]')];

      keyPoints = [
      (angleBlocks[1].querySelector('.container')
          .getBoundingClientRect().bottom - 20 + pageYOffset - headerHeight),
      (angleBlocks[2].querySelector('.iconbox_icon-wrap')
          .getBoundingClientRect().bottom - 75 + pageYOffset - headerHeight - cornerVertical),
      (angleBlocks[3].querySelector('.container')
          .getBoundingClientRect().bottom - 5 + pageYOffset - headerHeight),
    ];

    pathArray = [
      `M ${width * .9351} 0`,
      cornerBottomRight,
      `H ${width * .1191}`,
      cornerTopLeft,
      `V${keyPoints[0]}`,
      cornerBottomLeft,
      `H${width * .91}`,
      cornerTopRight,
      `V${keyPoints[1]}`,
      cornerBottomRight,
      `H${width * .09}`,
      cornerTopLeft,
      `V${keyPoints[2]}`,
      cornerBottomLeft,
      `H${width * .888}`,
      cornerTopRight,
      `V${svgHeight}`
    ];

    pathArrayHeights = [
      0,
      cornerVertical,
      cornerVertical,
      cornerVertical * 2,
      keyPoints[0],
      keyPoints[0] + cornerVertical,
      keyPoints[0] + cornerVertical,
      keyPoints[0] + cornerVertical * 2,
      keyPoints[1],
      keyPoints[1] + cornerVertical,
      keyPoints[1] + cornerVertical,
      keyPoints[1] + cornerVertical * 2,
      keyPoints[2],
      keyPoints[2] + cornerVertical,
      keyPoints[2] + cornerVertical * 2,
      svgHeight
    ]
  } else {
    cornerVertical = 40;
    cornerHorizontal = 40;

    cornerBottomRight = `s0 ${cornerVertical} ${0 - cornerHorizontal} ${cornerVertical}`;
    cornerTopLeft = `s${0 - cornerHorizontal} 0 ${0 - cornerHorizontal} ${cornerVertical}`;
    cornerBottomLeft = `s0 ${cornerVertical} ${cornerHorizontal} ${cornerVertical}`;
    cornerTopRight = `s${cornerHorizontal} 0 ${cornerHorizontal} ${cornerVertical}`;

    angleBlocksMobile = [...document.querySelectorAll('[data-line-mobile]')];

    keyPoints = [
      angleBlocksMobile[0].querySelector('.container')
          .getBoundingClientRect().bottom + pageYOffset - headerHeight,

      angleBlocksMobile[1].querySelector('.iconbox_icon-wrap')
          .getBoundingClientRect().top + pageYOffset - headerHeight +
      (angleBlocksMobile[1].querySelector('.iconbox_icon-wrap').offsetHeight / 2) - cornerVertical,

      angleBlocksMobile[2].querySelector('.iconbox_icon-wrap')
          .getBoundingClientRect().top + pageYOffset - headerHeight +
      (angleBlocksMobile[2].querySelector('.iconbox_icon-wrap').offsetHeight / 2) - cornerVertical,

      angleBlocksMobile[3].querySelector('.iconbox_icon-wrap')
          .getBoundingClientRect().top + pageYOffset - headerHeight +
      (angleBlocksMobile[3].querySelector('.iconbox_icon-wrap').offsetHeight / 2) - cornerVertical,

      angleBlocksMobile[4].querySelector('.iconbox_icon-wrap')
          .getBoundingClientRect().top + pageYOffset - headerHeight +
      (angleBlocksMobile[4].querySelector('.iconbox_icon-wrap').offsetHeight / 2) - cornerVertical,

      angleBlocksMobile[5].querySelector('.container')
          .getBoundingClientRect().bottom + pageYOffset - headerHeight + 10
    ];

    pathArray = [
      `M4 0`,
      `V${keyPoints[0]}`,
      cornerBottomLeft,
      `H${width - cornerHorizontal - 4}`,
      cornerTopRight,
      `V${keyPoints[1]}`,
      cornerBottomRight,
      `H${4 + cornerHorizontal}`,
      cornerTopLeft,
      `V${keyPoints[2]}`,
      cornerBottomLeft,
      `H${width - cornerHorizontal - 4}`,
      cornerTopRight,
      `V${keyPoints[3]}`,
      cornerBottomRight,
      `H${34 + cornerHorizontal}`,
      cornerTopLeft,
      `V${keyPoints[4]}`,
      cornerBottomLeft,
      `H${width - cornerHorizontal - 10}`,
      cornerTopRight,
      `V${keyPoints[5]}`,
      cornerBottomRight,
      `H${4 + cornerHorizontal}`,
      cornerTopLeft,
      `V${svgHeight}`
    ];

    pathArrayHeights = [
      0,
      keyPoints[0],
      keyPoints[0] + cornerVertical,
      keyPoints[0] + cornerVertical,
      keyPoints[0] + cornerVertical * 2,
      keyPoints[1],
      keyPoints[1] + cornerVertical,
      keyPoints[1] + cornerVertical,
      keyPoints[1] + cornerVertical * 2,
      keyPoints[2],
      keyPoints[2] + cornerVertical,
      keyPoints[2] + cornerVertical,
      keyPoints[2] + cornerVertical * 2,
      keyPoints[3],
      keyPoints[3] + cornerVertical,
      keyPoints[3] + cornerVertical,
      keyPoints[3] + cornerVertical * 2,
      keyPoints[4],
      keyPoints[4] + cornerVertical,
      keyPoints[4] + cornerVertical,
      keyPoints[4] + cornerVertical * 2,
      keyPoints[5],
      keyPoints[5] + cornerVertical,
      keyPoints[5] + cornerVertical,
      keyPoints[5] + cornerVertical * 2,
      svgHeight
    ];
  }

  if (type === 'resize' && wrapper.querySelector('svg')) {
    wrapper.querySelector('svg').remove();
  }
  const windowBottom = pageYOffset + window.innerHeight + 10;

  if (type === 'build' || type === 'resize') {
    currentSvg = SVG().addTo(wrapper).viewbox(`0 0 ${width} ${svgHeight}`);
    currentPath = currentSvg.path(pathArray.join(' '));

    pathLength = currentPath.length();

    if (window.innerWidth <= 767) {
      pathLength += 100;
    }

    if (currentPath) {
      currentPath.node.setAttribute('stroke-dasharray', pathLength);
      currentPath.node.setAttribute('stroke-dashoffset', pathLength);
      currentPath.node.setAttribute('vector-effect', 'non-scaling-stroke');
      currentPath.node.setAttribute('class', 'not-animate');
      currentPath.node.setAttribute('style', `animation-duration: ${animationDuration / 1000}s`);
    }
  }

  if (windowBottom - headerHeight > height) {
    animateLine(true);
  } else {
    const checkHeight = (windowBottom - headerHeight) * svgHeight / height;
    const arrayCheckLength = pathArrayHeights.findIndex(el => el > checkHeight);
    let arrayCheck;
    if (arrayCheckLength >= pathArray.length - 2) {
      animateLine(true);
    } else {
      arrayCheck = pathArray.slice(0, arrayCheckLength + 1);
      animateLine(false, arrayCheck, checkHeight, pathLength);
    }
  }

  function animateLine (completeAnimation, pathArrayCheck, checkHeight, mainPathLength) {
    let animateFor, pathPart
    if (completeAnimation) {
      pathPart = 1;
      animationComplete = true;
    } else {
      let buildArray = [...pathArrayCheck];
      let lastPathEl = buildArray.pop();
      if (lastPathEl && lastPathEl[0] === 'V') {
        lastPathEl = `V${checkHeight}`;
      }
      buildArray.push(lastPathEl);
      const checkPath = SVG().path(buildArray.join(' '));
      pathPart = checkPath.length() / mainPathLength;
    }
    let animationProcess = () => {
      currentPath.node.classList.remove('animate');
      currentlyAnimated += animateFor;
      if (currentlyAnimated >= animationDuration) {
        animationComplete = true;
        window.removeEventListener('scroll', debounce);
      }
      nowAnimatingFor = 0;
      animationStartedAt = 0;
      animateTimeout = null;
      animationOrder = [];
    }
    function animateOrderBuilder (animationData) {
      if ((animationOrder[0] && animationData > animationOrder[0]) || (!animationOrder[0] && animationData)) {

        let currentAnimationLength = 0;
        let time;
        let type;
        animateFor = animationData * animationDuration - (currentlyAnimated + currentAnimationLength);

        if (animationOrder.length > 0) {
          // currentAnimationLength = animationOrder[animationOrder.length - 1] * animationDuration;
          type = 'continue';
        } else {
          animationOrder.push(animationData)
          type = 'start';
          nowAnimatingFor = animateFor;
        }

        if (animateTimeout) {clearTimeout(animateTimeout)}
        if (type === 'start') {
          time = animateFor;
          animationStartedAt = Date.now() + 30;
        } else {
          time = animationStartedAt + nowAnimatingFor + animateFor - Date.now() + 50;
          nowAnimatingFor = nowAnimatingFor + time;
        }
        animateTimeout = setTimeout(animationProcess, time);
      }
    }
    currentPath.node.classList.add('animate');
    animateOrderBuilder (pathPart);
  }
}

function checkScrollDirection () {
  const st = window.pageYOffset || document.documentElement.scrollTop;

  if (animationComplete) {
    window.clearTimeout(debounce_timer);
  } else if (st > lastScrollPosition) {
    generateSVGs('scroll');
  }

  lastScrollPosition = st;
}

let debounce_timer;

function debounce (e) {
  if(debounce_timer) {
    window.clearTimeout(debounce_timer);
  }
  if (e.type === 'resize' && windowSize.width !== window.innerWidth) {
    debounce_timer = window.setTimeout(function() {
      windowSize.width = window.innerWidth;
      windowSize.height = window.innerHeight;
      oldPathLength = pathLength;
      pathLength = 0;
      resetGlobal();
      setHomepage('resize')
    }, 300);
  } else {
    debounce_timer = window.setTimeout(function() {
      const st = window.pageYOffset
      if (animationComplete) {
        window.clearTimeout(debounce_timer)
      } else if (st > lastScrollPosition) {
        generateSVGs('scroll');
      }
      lastScrollPosition = st;
    }, 300);
  }
}

var sliderInstance;

function slider () {
  if (sliderInstance) {
    sliderInstance.destroy();
  }
  sliderInstance = tns({
    container: '.testimonials-slider',
    items: 1,
    autoplay: true,
    autoplayTimeout: 10000,
    prevButton: '.slider-prev',
    nextButton: '.slider-next',
    speed: 1800,
    nav: true,
    navPosition: 'bottom',
    responsive: {
      768: {
        nav: false
      }
    }
  });
}


function homeBackgrounds () {
  const homeHero = document.querySelector('.hero-section-home');
  const homeWhiteBg = document.querySelector('.section--white-skew');
  const homePreFooter = document.querySelector('.pre-footer .container');

  document.querySelector('.home-hero-bg')
      .setAttribute('style', `height: ${homeHero.offsetHeight}px`);

  document.querySelector('.home-pre-footer-bg')
      .setAttribute(
          'style',
          `height: ${homePreFooter.offsetHeight}px; width: ${homePreFooter.offsetWidth / 2 + window.innerWidth / 2}px`
      );

  document.querySelector('.home-white-bg')
      .setAttribute(
          'style',
          `height: ${homeWhiteBg.offsetHeight}px; top: ${homeWhiteBg.getBoundingClientRect().top + pageYOffset - headerHeight}px`
      );

  homeHero.addEventListener('.resize', function() {
    document.querySelector('.home-hero-bg')
        .setAttribute('style', `height: ${this.offsetHeight}px`);
  });

  homePreFooter.addEventListener('resize', function() {
    document.querySelector('.home-pre-footer-bg')
        .setAttribute(
            'style',
            `height: ${this.offsetHeight}px; width: ${this.offsetWidth / 2 + window.innerWidth / 2}px`
        );
  });

  homeWhiteBg.addEventListener('resize', function() {
    document.querySelector('.home-white-bg')
        .setAttribute(
            'style',
            `height: ${this.offsetHeight}px; top: ${this.getBoundingClientRect().top + pageYOffset - headerHeight}px`
        );
  });
}

function setHomepage (type) {
  slider()
  let images = document.images;
  let len = images.length;
  let counter = 0;

  [].forEach.call( images, function( img ) {

    if (img.classList.contains('set-dimensions')) {
      const ratio = img.getAttribute('width')/img.getAttribute('height');
      img.setAttribute('height', img.parentNode.clientWidth / ratio);
    }

    if(img.complete)
      incrementCounter();
    else
      img.addEventListener( 'load', incrementCounter, false );

  });

  function incrementCounter() {
      counter++;
      if ( counter === len ) {
        setTimeout(() => {
          homeBackgrounds();
          generateSVGs(type);
        }, 200)
      }
  }
}

function resetGlobal () {
  currentlyAnimated = 0;
  currentSvg = null;
  currentPath = null;
  lastScrollPosition = 0;
  animationComplete = false;
  animateTimeout = null;
  nowAnimatingFor = 0;
  animationStartedAt = 0;
  animationOrder = [];
}

document.addEventListener('DOMContentLoaded', function () {
  resetGlobal();
  setHomepage('build');
  window.addEventListener('resize', debounce);
  window.addEventListener('scroll', debounce);
});
